import { Pipe, PipeTransform } from '@angular/core';
import { CommonUtilty } from 'app/BaseFramework/core/utilities/commonUtility';
import { LookupDataService } from '../../../core/http/lookupdata.service'

@Pipe({
  name: 'technicalTranslate',
  pure: false
})
export class TechnicalTranslatePipe implements PipeTransform {

  constructor(private lookupDataService: LookupDataService, private commonUtilty: CommonUtilty) {
  }

  returnBackGenericDescriptionIfLookupSpecificNotPresent: boolean = false;

  transform(value: any, lookupCd?: any): any {
    if (value && typeof value == 'string' && value.includes(',')) {
      let dataList = this.commonUtilty.splitMulti(value)
      if (dataList && this.commonUtilty.isArrayIterable(dataList)) {
        let output: any = dataList.map(item => this._masterTranslateForSingleLabel(item, lookupCd))
        output = this.commonUtilty.convertArrayToCSV(output)
        //Adding spaces after commas for readability
        if (output && typeof output == 'string')
          output = output.replace(',', ', ')
        return output
      }
    }
    else {
      return this._masterTranslateForSingleLabel(value, lookupCd)
    }
  }

  _masterTranslateForSingleLabel(value: any, lookupCd?: any) {
    if (lookupCd) {
      let output = this.getLookupCdSpecificDescription(value, lookupCd)
      return output
    }
    else {
      let output = this.getGenericLookupDescription(value)
      return output
    }
  }

  getGenericLookupDescription(key: any) {
    return this.lookupDataService.technicalLabelMap[key] ? this.lookupDataService.technicalLabelMap[key] : this.capitalizeFirstLetter(key)
  }

  getLookupCdSpecificDescription(key, lookupCd) {
    if (this.lookupDataService.technicalLabelLookupSpecificMap[lookupCd])
      return this.lookupDataService.technicalLabelLookupSpecificMap[lookupCd][key] ? this.lookupDataService.technicalLabelLookupSpecificMap[lookupCd][key] : this.capitalizeFirstLetter(key)
    else if (this.returnBackGenericDescriptionIfLookupSpecificNotPresent) {
      return this.getGenericLookupDescription(key)
    }
    else {
      let me = this
      if (lookupCd) {
        this.lookupDataService.getLookup(lookupCd).subscribe(resp => {
          let output = me.lookupDataService.technicalLabelLookupSpecificMap[lookupCd] && me.lookupDataService.technicalLabelLookupSpecificMap[lookupCd][key] ? me.lookupDataService.technicalLabelLookupSpecificMap[lookupCd][key] : this.capitalizeFirstLetter(key)
          return output
        })
        return me.lookupDataService.technicalLabelLookupSpecificMap[lookupCd] && me.lookupDataService.technicalLabelLookupSpecificMap[lookupCd][key] ? me.lookupDataService.technicalLabelLookupSpecificMap[lookupCd][key] : this.capitalizeFirstLetter(key)
      }
    }
  }

  capitalizeFirstLetter(value) {
    if (value && typeof value.charAt === "function" && typeof value.slice === "function") {
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    }
    else {
      return value
    }
  }

}

